import { Button, Card, Grid, MenuItem, Select, Switch } from "@mui/material";
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput";
import { couponTypeOptions, couponUsageOptions, regexNumber } from "helper/constant";
import React, { useEffect, useState } from "react";
import { createCoupon, getCoupon, updateCoupon } from "services/couponService";
import { getPropertiesId } from "services/propertiesService";
import { useParams } from 'react-router-dom';
import moment from "moment";
import { WBLabel } from "components/_WBcomponents/WBLabel";
import ReactQuill from "react-quill";
import { NumericFormat } from "react-number-format";
import { currencyFormat } from "helper/numberHelper";
import DeleteIcon from '@mui/icons-material/Delete';
import { addJastip } from "services/jastipService";
import { getEventList } from "services/eventService";
import DropZoneComponent from "components/_WBcomponents/DropzoneComponent";
import { isSuperAdmin } from "helper/localStorage";
import { handleUpload } from "helper/S3";
import { getCustomerList } from "services/customerService";
import CustomerDropDown from "components/_WBcomponents/CustomerDropDown";

var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
];

function JastipForm ({
    loadData
}) {

    const [ form, setForm ] = useState({
        custName: "",
        custPhoneNumber: "",
        shoppingRequest: [],
        additionalFee: [],
        totalPrice: 0,
        status: "",
        addressDetail: {
            streetName: ""
        },
        isReseller: false,
        downPayment: false,
        images: [],
        qty: "",
        qtyType: "",
        price: "",
        totalPrice: "",
        dp: null
    })
    const [ shoppingRequest, setShoppingRequest ] = useState({
        name: "",
        image: "",
        qty: 1,
        qtyType: "",
        price: "",
        totalPrice: "",
    })
    const [ additionalFee, setAdditionalFee ] = useState({
        information: "",
        totalPrice: ""
    })
    const [ properties, setProperties ] = useState([])
    const [ users, setUsers ] = useState([])
    const [ loading, setLoading ] = useState(false)
    const [ events, setEvents ] = useState([])
    const [ closeDropDown, setCloseDropDown ] = useState(false)
    const [ onAllowFilter, setOnAllowFilter ] = useState(false)

    useEffect(() => {
        loadEvents()
    }, [])

    useEffect(() => {
        console.log(form, form.shoppingRequest)
    }, [form])

    const onChange = (e) => {
        setForm((prev) => ({
            ...prev,
            ...e
        }))
    }

    const loadEvents = async () => {
        let { data, error } = await getEventList({ type: 'jastip' })
        if (error) { console.log(error) }
        if (data) { 
            setEvents(data.map(v => {
                return {
                    value: v._id,
                    label: v.eventName
                }
            }))
        }
    }

    const onChangeShopping = (e) => {
        setShoppingRequest(prev => ({
            ...prev,
            ...e
        }))
    }

    const addShoppingRequest = async () => {
        try {
            setShoppingRequest({
                name: "",
                image: "",
                qty: 1,
                qtyType: "",
                price: "",
                totalPrice: "",
            })
            onChange({
                shoppingRequest: [...form.shoppingRequest, shoppingRequest]
            })
        } catch (error) {
            console.log(error)
        }
    }

    const deleteShoppingRequest = async (index) => {
        setLoading(true)
        try {
            form.shoppingRequest.splice(index, 1)
            onChange({
                shoppingRequest: form.shoppingRequest
            })
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }


    const onChangeAdditionalFee = (e) => {
        setAdditionalFee(prev => ({
            ...prev,
            ...e
        }))
    }

    const addAdditonalFee = async () => {
        try {
            setAdditionalFee({
                information: "",
                totalPrice: "",
            })
            onChange({
                additionalFee: [...form.additionalFee, additionalFee]
            })
        } catch (error) {
            console.log(error)
        }
    }

    const deleteAdditionalFee = async (index) => {
        setLoading(true)
        try {
            form.additionalFee.splice(index, 1)
            onChange({
                additionalFee: form.additionalFee
            })
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const saveJastip = async () => {
        setLoading(true)
        try {
            // upload image to S3
            let images = []
            for (let i = 0; i < form.images.length; i ++) {
                if (form.images[i].name) {
                    let currImages = await handleUpload({
                        selectedFile: form.images[i],
                        dirName: 'product'
                    })
                    images.push(currImages[0])
                } else {
                    images.push(form.images[i])
                }
            }
            let { data, error } = await addJastip({
                ...form,
                images,
                events: form.events ? form.events.value : ''
            })
            loadData()
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const deleteAddonImages = (index) => {
        let currImages = form.images
        currImages.splice(index, 1);
        onChange({ images: currImages })
    }
    
    return (
        <Grid container xs={12} lg={12} p={2} pt={0} spacing={1} onClick={() => {
            setCloseDropDown(true)
        }}>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBSelect label={"Jastip Event"} inDialog={true} options={events} onChange={(e) => {
                        onChange({ events: e })
                    }} value={form.events}/>
                </Grid>
            </Grid>
            <Grid item xs={6} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Customer Name"} onChange={(e) => {
                        onChange({custName: e.currentTarget.value.toUpperCase()})
                    }} value={form.custName}/>
                </Grid>
            </Grid>
            <Grid item xs={6} lg={4} spacing={1}>
                {
                    isSuperAdmin() &&
                    <Grid item xs={12}>
                        <WBInput label={"Phone Number"} onChange={(e) => {
                            if (!regexNumber(e.currentTarget.value)) { return }
                            onChange({custPhoneNumber: e.currentTarget.value})
                            setOnAllowFilter(true)
                        }} value={form.custPhoneNumber}/>
                        {
                            onAllowFilter &&
                            <CustomerDropDown
                                phoneNumber={form.custPhoneNumber} 
                                closeDropDown={closeDropDown}
                                setCloseDropDown={(e) => { setCloseDropDown(e) }}
                                onChange={(e) => { onChange(e) }}
                                setAllowFilter={(e) => { setOnAllowFilter(e) }}
                            />
                        }
                    </Grid>
                }
            </Grid>
            <Grid container item xs={12} lg={12} spacing={2}>
                <Grid item>
                    <WBLabel style={{
                        marginLeft: 10,
                        color: 'rgb(133, 133, 133)'
                    }}>Reseller</WBLabel>
                    <Switch onChange={() => {
                        onChange({
                            isReseller: !form.isReseller
                        })
                    }} />
                </Grid>
                <Grid item>
                    <WBLabel style={{
                        marginLeft: 10,
                        color: 'rgb(133, 133, 133)'
                    }}>DP</WBLabel>
                    <Switch onChange={() => {
                        onChange({
                            downPayment: !form.downPayment
                        })
                    }} />
                </Grid>
                <Grid item>
                    <WBLabel style={{
                        color: "rgb(133, 133, 133)"
                    }}>Input DP Value</WBLabel>
                    <NumericFormat 
                        value={form.dp}
                        isAllowed={(values) => {
                            const {floatValue} = values;
                            // if (form.couponType.value == "percentage") { 
                            //     if (floatValue > 100) { return false }
                            // }
                            return true
                        }}
                        onValueChange={(values) => {
                            const {formattedValue, value, floatValue} = values;
                            // do something with floatValue
                            onChange({ dp: value.replace(/^0+/, '') })
                        }}
                        // disabled={form._id}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowedDecimalSeparators={false}
                        allowNegative={false}
                        thousandSeparator
                        customInput={WBInput}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBInput type={"textarea"} label={"Customer Address"} onChange={(e) => {
                        onChange({addressDetail: {
                            streetName: e.currentTarget.value.toUpperCase()
                        }})
                    }} value={form.addressDetail.streetName}/>
                </Grid>
            </Grid>
            <Grid item mt={1} xs={12} md={12}>
                <WBLabel bold style={{
                    color: 'rgb(133, 133, 133)'
                }}>Upload Image</WBLabel>
                <DropZoneComponent
                    className="drop-zone"
                    uploadName='addonImage'
                    file={form.images}
                    isMultiple={true}
                    onDrop={(files) => {
                        // if (files.length >= 4) { return; }
                        let currImages = form.images ? form.images : []
                        for (let i = 0; i < files.length; i++) {
                            currImages = currImages.concat(files[i])
                        }
                        onChange({ images: currImages })
                    }}
                >
                    <div className='dropzone mb-0' style={{
                        textAlign: 'center',
                        minHeight: '150px'
                    }}>
                    <div style={{ padding: 10, alignItems: 'center' }}>
                        <label>
                            <i className='fa fa-upload mr-1' />
                            Drop itemImages to upload
                        </label>
                        <br />
                        <br />
                        <label
                            htmlFor={"addonImage"}
                            style={{ cursor: 'pointer' }}
                            className='dropzone-child mb-0'>
                            or Click to Browse
                        </label>
                        <div style={{ overflowX: 'auto' }}>
                            {
                                form.images &&
                                <div style={{ textAlign: 'left' }}>
                                    Uploaded file :
                                    <div className='d-flex'>
                                    {
                                        form.images.map((value, index) => {
                                            return (
                                                <div key={`${value.name}`} className='d-flex mb-1' style={{ textAlign: 'left' }}>
                                                    <img src={(!value.name && value.includes("https")) ? value : URL.createObjectURL(value)} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                                        onClick={() => { }}
                                                    />
                                                    <label className='mt-1 mb-0 ml-1' style={{ alignItems: 'flex-end' }}>
                                                        {value.name}
                                                        <span style={{ marginLeft: 5, color: 'gray', cursor: 'pointer' }} onClick={() => {
                                                            deleteAddonImages(index)
                                                        }}>X</span>
                                                    </label>
                                                </div>
                                            )
                                        })
                                    }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    </div>
                </DropZoneComponent>
            </Grid>
            <Grid container item mt={1} xs={12} md={12} spacing={1}>
                <Grid item xs={8} md={4.5} lg={1.5}>
                    <WBInput label={"Qty / Weight"} onChange={(e) => {
                        if (!regexNumber(e.currentTarget.value)) { return }
                        onChange({
                            qty: e.currentTarget.value,
                            totalPrice: e.currentTarget.value * shoppingRequest.price
                        })
                    }}  value={form.qty}/>
                </Grid>
                <Grid item xs={4} md={1.5} lg={1.5}>
                    {/* <WBInput styles={{
                        marginTop: 2.5
                    }} onChange={(e) => {
                        onChangeShopping({type: e.currentTarget.value})
                    }}  value={shoppingRequest.type}/> */}
                    <Select 
                        sx={{
                            marginTop: 2.2,
                            borderRadius: 2,
                            height: 41,
                            minWidth: 80,
                            "& .MuiOutlinedInput-root": {
                                "&.Mui-focused fieldset": {
                                    borderColor: "#2196f3", // #d8f0e9 #64a591
                                },
                                "&:hover fieldset": {
                                    borderColor: '#2196f3',
                                },
                                "&.Mui-disabled input": {
                                    backgroundColor: "#f5f5f5"
                                }
                            },
                        }}
                        value={form.qtyType}
                        onChange={(e) => {
                            console.log(e)
                            onChange({qtyType: e.target.value})
                        }}
                        // input={<WBInput />}
                    >
                        {["kg", "pcs"].map((name) => (
                            <MenuItem key={name} value={name}>
                                {name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            {
                isSuperAdmin() &&
                <>
                    <Grid item xs={12} md={6} lg={2.8}>
                        <WBLabel style={{
                            color: "rgb(133, 133, 133)"
                        }}>Price {form.qtyType ? `/${form.qtyType}` : ''}</WBLabel>
                        <NumericFormat value={form.price}
                            isAllowed={(values) => {
                                const {floatValue} = values;
                                // if (form.couponType.value == "percentage") { 
                                //     if (floatValue > 100) { return false }
                                // }
                                return true
                            }}
                            onValueChange={(values) => {
                                const {formattedValue, value, floatValue} = values;
                                // do something with floatValue
                                onChange({ 
                                    price: value.replace(/^0+/, ''),
                                    totalPrice: value.replace(/^0+/, '') * form.qty
                                })
                            }}
                            // disabled={form._id}
                            decimalScale={0}
                            allowLeadingZeros={false}
                            allowedDecimalSeparators={false}
                            allowNegative={false}
                            thousandSeparator
                            customInput={WBInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={2.8}>
                        <WBLabel style={{
                            color: "rgb(133, 133, 133)"
                        }}>Total Price</WBLabel>
                        <NumericFormat value={form.totalPrice}
                            isAllowed={(values) => {
                                const {floatValue} = values;
                                // if (form.couponType.value == "percentage") { 
                                //     if (floatValue > 100) { return false }
                                // }
                                return true
                            }}
                            onValueChange={(values) => {
                                const {formattedValue, value, floatValue} = values;
                                // do something with floatValue
                                onChange({ totalPrice: value.replace(/^0+/, '') })
                            }}
                            // disabled={form._id}
                            decimalScale={0}
                            allowLeadingZeros={false}
                            allowedDecimalSeparators={false}
                            allowNegative={false}
                            thousandSeparator
                            customInput={WBInput}
                        />
                    </Grid>
                </>
            }
            </Grid>
            {/* Product Request */}
            <div style={{
                marginTop: 48,
                padding: 10,
                marginLeft: 8,
                width: '100%',
                borderRadius: 10,
                border: 'solid 0.5px gray'
            }}>
                <Grid item container xs={12} lg={12} spacing={1} style={{
                    position: 'relative',
                    padding: 10,
                    marginTop: -30,
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: 12,
                    minHeight: 120,
                }}>
                    <Grid item xs={12} mt={1}>
                        {/* <WBSelect label={"Request"} options={couponUsageOptions} onChange={(e) => {
                            onChange({price: e})
                        }} value={form.price}/> */}
                        <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Product Request</WBLabel>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3.3}>
                        <WBInput label={"Product Name"} onChange={(e) => {
                            onChangeShopping({name: e.currentTarget.value.toUpperCase()})
                        }}  value={shoppingRequest.name}/>
                    </Grid>
                    {
                        isSuperAdmin() &&
                        <>
                            <Grid item xs={12} md={6} lg={2.8}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                                <NumericFormat value={shoppingRequest.price}
                                    isAllowed={(values) => {
                                        const {floatValue} = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const {formattedValue, value, floatValue} = values;
                                        // do something with floatValue
                                        onChangeShopping({ 
                                            price: value.replace(/^0+/, ''),
                                            totalPrice: value.replace(/^0+/, '') * shoppingRequest.qty
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                        </>
                    }
                    <Grid item xs={12} lg={12} mt={1} textAlign={"right"}>
                        <div style={{marginTop: 12}}/>
                        <Button variant="contained" 
                        disabled={
                            !shoppingRequest.name ||
                            !shoppingRequest.qty 
                            // || !shoppingRequest.price
                        }
                        onClick={() => {
                            addShoppingRequest()
                        }}>Add</Button>
                    </Grid>
                </Grid>
                {/* Product Request List */}
                <Grid container item spacing={1} mt={1} style={{
                    minHeight: 100
                }}>
                    <Grid item xs={12} mt={1}>
                        {/* <WBSelect label={"Request"} options={couponUsageOptions} onChange={(e) => {
                            onChange({price: e})
                        }} value={form.price}/> */}
                        <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Product Request List : </WBLabel>
                    </Grid>
                    {
                        form.shoppingRequest.map((value, index) => {
                            return (
                                <Grid item lg={3} md={3} xs={12}>
                                    <Card>
                                        <Grid container p={2}>
                                            <Grid item xs={11}>
                                                <Grid>
                                                    <WBLabel bold>{value.name} {value.qty} {value.qtyType}</WBLabel>
                                                </Grid>
                                                {
                                                    isSuperAdmin() &&
                                                    <>
                                                    {/* <Grid>
                                                        <WBLabel>{currencyFormat(value.price)} x {value.qty}</WBLabel>
                                                    </Grid> */}
                                                    <Grid>
                                                        <WBLabel bold>{currencyFormat(value.totalPrice)}</WBLabel>
                                                    </Grid>
                                                    </>
                                                }
                                            </Grid>
                                            <Grid textAlign={"right"} item xs={1}>
                                                <div style={{
                                                    cursor: 'pointer'
                                                }} onClick={() => {
                                                    deleteShoppingRequest(index)
                                                }}>
                                                    <DeleteIcon color="black" />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </div>
            {/* Additional Fee */}
            <div style={{
                marginTop: 48,
                padding: 10,
                marginLeft: 8,
                width: '100%',
                borderRadius: 10,
                border: 'solid 0.5px gray'
            }}>
                <Grid item container xs={12} lg={12} spacing={1} style={{
                    position: 'relative',
                    padding: 10,
                    marginTop: -30,
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: 12,
                    minHeight: 120,
                }}>
                    <Grid item xs={12} mt={1}>
                        {/* <WBSelect label={"Request"} options={couponUsageOptions} onChange={(e) => {
                            onChange({price: e})
                        }} value={form.price}/> */}
                        <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Additional Fee</WBLabel>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3.3}>
                        <WBInput label={"Information"} onChange={(e) => {
                            onChangeAdditionalFee({information: e.currentTarget.value.toUpperCase()})
                        }}  value={additionalFee.information}/>
                    </Grid>
                    {
                        isSuperAdmin() &&
                        <>
                            <Grid item xs={12} md={6} lg={2.8}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Price (/ Item)</WBLabel>
                                <NumericFormat value={additionalFee.totalPrice}
                                    isAllowed={(values) => {
                                        const {floatValue} = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const {formattedValue, value, floatValue} = values;
                                        // do something with floatValue
                                        onChangeAdditionalFee({ 
                                            totalPrice: value.replace(/^0+/, '')
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                        </>
                    }
                    <Grid item xs={12} lg={12} mt={1} textAlign={"right"}>
                        <div style={{marginTop: 12}}/>
                        <Button variant="contained" 
                        disabled={
                            !additionalFee.information ||
                            !additionalFee.totalPrice
                            // || !shoppingRequest.price
                        }
                        onClick={() => {
                            addAdditonalFee()
                        }}>Add</Button>
                    </Grid>
                </Grid>
                <Grid container item spacing={1} mt={1} style={{
                    minHeight: 100
                }}>
                    <Grid item xs={12} mt={1}>
                        {/* <WBSelect label={"Request"} options={couponUsageOptions} onChange={(e) => {
                            onChange({price: e})
                        }} value={form.price}/> */}
                        <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Additional Fee(s) : </WBLabel>
                    </Grid>
                    {
                        form.additionalFee.map((value, index) => {
                            return (
                                <Grid item lg={3} md={3} xs={12}>
                                    <Card>
                                        <Grid container p={2}>
                                            <Grid item xs={11}>
                                                <Grid>
                                                    <WBLabel bold>{value.information}</WBLabel>
                                                </Grid>
                                                {
                                                    isSuperAdmin() &&
                                                    <>
                                                    {/* <Grid>
                                                        <WBLabel>{currencyFormat(value.price)} x {value.qty}</WBLabel>
                                                    </Grid> */}
                                                    <Grid>
                                                        <WBLabel bold>{currencyFormat(value.totalPrice)}</WBLabel>
                                                    </Grid>
                                                    </>
                                                }
                                            </Grid>
                                            <Grid textAlign={"right"} item xs={1}>
                                                <div style={{
                                                    cursor: 'pointer'
                                                }} onClick={() => {
                                                    deleteAdditionalFee(index)
                                                }}>
                                                    <DeleteIcon color="black" />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </div>
            <Grid sx={{
                padding: 1,
            }}>
                <Grid item>
                    <WBLabel bold style={{
                        color: "rgb(133, 133, 133)"
                    }}>Discount : </WBLabel>
                    <NumericFormat 
                        value={form.discount}
                        isAllowed={(values) => {
                            const {floatValue} = values;
                            // if (form.couponType.value == "percentage") { 
                            //     if (floatValue > 100) { return false }
                            // }
                            return true
                        }}
                        onValueChange={(values) => {
                            const {formattedValue, value, floatValue} = values;
                            // do something with floatValue
                            onChange({ discount: value.replace(/^0+/, '') })
                        }}
                        // disabled={form._id}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowedDecimalSeparators={false}
                        allowNegative={false}
                        thousandSeparator
                        customInput={WBInput}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} mt={1} textAlign={"right"}>
                <Button variant="contained" 
                disabled={
                    !form.custName ||
                    // !form.custPhoneNumber ||
                    !form.qty || !form.qtyType ||
                    // !form.shoppingRequest || (form.shoppingRequest && form.shoppingRequest.length <= 0) ||
                    loading
                }
                onClick={() => {
                    saveJastip()
                }}>Save</Button>
            </Grid>
        </Grid>
    )
}

export default JastipForm